import React from 'react';
import { ToastContainer, toast, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './GenericToaster.css'; // Import custom CSS

/**
 * GenericToaster Component
 * 
 * A wrapper around react-toastify's ToastContainer with customizable colors.
 * Color customization is done via CSS variables that can be overridden in GenericToaster.css
 */
const GenericToaster = (props) => {
  return (
    <ToastContainer
      position="bottom-right"
      autoClose={5000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      transition={Bounce}
      {...props}
    />
  );
};

// Helper functions for consistent toast usage
const getToastId = (message) => message.toString().substring(0, 100);

export const showSuccessToast = (message, options = {}) => {
  toast.success(message, {
    toastId: getToastId(message),
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
    className: 'toast-success',
    ...options
  });
};

export const showErrorToast = (message, options = {}) => {
  toast.error(message, {
    toastId: getToastId(message),
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
    className: 'toast-error',
    ...options
  });
};

export const showInfoToast = (message, options = {}) => {
  toast.info(message, {
    toastId: getToastId(message),
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
    className: 'toast-info',
    ...options
  });
};

export const showWarningToast = (message, options = {}) => {
  toast.warn(message, {
    toastId: getToastId(message),
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
    className: 'toast-warning',
    ...options
  });
};

export default GenericToaster;
